export const types = {
  SET_VISIBILITY: 'ScrollSpy/visibility',
}

export default {
  setVisibility: function({ name, group, visible, top }) {
    return {
      type: types.SET_VISIBILITY,
      name,
      group,
      visible,
      top
    }
  },
}
